import { Link } from 'react-router-dom';
import { FileText, CheckCircle2 } from 'lucide-react';
import type { Course } from '../hooks/useApi';

interface CourseCardProps {
  course: Course;
  completedLessons?: number;
}

export default function CourseCard({ course, completedLessons = 0 }: CourseCardProps) {
  const totalLessons = course.lesson_count || 0;
  const isComplete = completedLessons > 0 && completedLessons === totalLessons;

  return (
    <Link
      to={`/courses/${course.slug}`}
      className="group block bg-background-secondary rounded-xl p-5 border border-gray-800 hover:border-gray-600 card-lift"
    >
      <div className="flex items-start justify-between gap-3">
        <div className="flex-1 min-w-0">
          <h3 className="font-semibold text-white group-hover:text-accent-blue transition-colors">
            {course.title}
          </h3>
          <p className="text-sm text-gray-400 mt-1.5 line-clamp-2">
            {course.description}
          </p>
          <div className="flex items-center gap-4 mt-3 text-sm text-gray-500">
            <span className="flex items-center gap-1.5">
              <FileText className="w-4 h-4" />
              {totalLessons} {totalLessons === 1 ? 'lesson' : 'lessons'}
            </span>
            {completedLessons > 0 && (
              <span className="flex items-center gap-1.5 text-accent-green">
                <CheckCircle2 className="w-4 h-4" />
                {completedLessons}/{totalLessons} done
              </span>
            )}
          </div>
        </div>
        {isComplete && (
          <div className="flex-shrink-0 p-1.5 bg-accent-green/10 rounded-full">
            <CheckCircle2 className="w-5 h-5 text-accent-green" />
          </div>
        )}
      </div>
    </Link>
  );
}
